// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------

import { useEffect, useState } from 'react'
import { GenericSolidButton, RedCancelButton } from '../UI/buttons/Button.styled'
import { H1, H2, Text } from '../UI/generalLayout/Layout.styled'
import { Auth } from '../../core/http/service/Auth'
import { ButtonAreaContainer, ModalContainer, ModalContentContainer } from './EmailModal.styled'
import { HelpIcon, InputLogin, InputWrapper } from '../loginFields/LoginFields.styled'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import Colors from '../../constants/Colors'
import helpIcon from "../../assets/imgs/helpIcon.svg";
import Modal from '@mui/material/Modal'


interface ICancelModal {
    Icon?: any;
    visible: boolean;
    user: any;
    onConfirm: any;
    modalTitle: string;
    modalSubtitle: string;
    cancelButtonMsg: string;
    colorButtonCancel?: string;
    colorButtonConfirm?: string;
    confirmButtonMsg: string;
}
/**
/**
 * A component that renders a Cancel modal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const EmailModal = ({visible, user, onConfirm, modalTitle, modalSubtitle, cancelButtonMsg, confirmButtonMsg, Icon = undefined, colorButtonCancel, colorButtonConfirm }: ICancelModal) => {
    // --------------------------------------------------------
    // CANCEL MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo(); 
    const [email, setEmail] = useState("")
    const [textColor, setTextColor] = useState("")
    const [inputEmailShow, setInputEmailShow] = useState(true)
    const [modalTitleModal, setModalTitle]= useState(modalTitle)
    const [modalSubtitleModal, setModalSubtitleModal]= useState(modalSubtitle)
    const [botaoEnviarEmail, setBotaoEnviarEmail]= useState(true)
    const [resposta, setResposta] = useState("")

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------

    useEffect(() => {
        if (!visible) {
            setEmail("")
            setTextColor("")
            setInputEmailShow(true)
            setModalTitle(modalTitle)
            setModalSubtitleModal(modalSubtitle)
            setBotaoEnviarEmail(true)
            setResposta("")
        }
    }, [visible, modalTitle, modalSubtitle])

    async function EnvioEmail() {
        if (email) {
            
            const service: Auth = new Auth();
            const callBackUrl = process.env.REACT_APP_CALLBACK_URL; //Mudar esse callback de acordo com o ambiente
            const params = {
              user: user,
              email: email,
              callbackUrl: callBackUrl,
            };
    
            try {

                if(email){

                    setTextColor("green")
                    setResposta("")

                    const result: any = await service.postEnvioEmail(params);

                    if(result && result.status == 200){
                        setModalSubtitleModal(result.data.data)
                        setInputEmailShow(false)
                        setModalTitle("Sucesso")
                        setBotaoEnviarEmail(false)
                    }else{
                        // Se e-mail já foi cadastrado
                        if(result && result.status == 202){    
                            setTextColor("red")
                            setResposta(result.data.errors[0])
                        }
                        else{
                            setModalSubtitleModal("A execução retornou erros : " + result.data.errors[0])
                            setInputEmailShow(false)
                            setModalTitle("Ops")
                            setBotaoEnviarEmail(false)
                        }
                    }
                }else{
                    setTextColor("red")
                    setResposta("Digite um E-mail válido!")
                }

                
            } catch (error: any) {
                console.error("Erro ao enviar email:", error);
            }
        } else {
            console.error("Email não está definido.");
        }
    }

    return (
        <>
            <Modal
                open={visible}
            >
                <ModalContainer isMobile={isMobile}>
                    <ModalContentContainer isMobile={isMobile}  style={{ marginTop: 55 }}>                        
                        {isMobile? <H2 style={{ color: '#0a5190'}}>{modalTitleModal}</H2> : <H1 style={{ color: '#0a5190'}}>{modalTitleModal}</H1> }
                        {isMobile? <Text style={{ fontSize: 15 }}>{modalSubtitleModal}</Text> : <H2 style={{ marginTop: 25 }}>{modalSubtitleModal}</H2>}
                        <InputWrapper>
                        {
                            inputEmailShow ? (
                                <>
                                    <InputLogin
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        placeholder="Digite seu e-mail"
                                    />
                                    {email === "" && (
                                        <div>
                                            <HelpIcon src={helpIcon} alt="help" />
                                        </div>
                                    )}
                                </>
                            ) : (
                                ''
                            )
                        }

                        </InputWrapper>

                        {
                            botaoEnviarEmail ? (
                                <>
                                    <ButtonAreaContainer style={{ marginTop: 35 }}>
                                        <RedCancelButton
                                        color={colorButtonCancel ? colorButtonCancel : ""}
                                            onClick={onConfirm}
                                        >
                                            {cancelButtonMsg}
                                        </RedCancelButton>
                                        <GenericSolidButton
                                            style={{ marginTop: isMobile? 12 : 0 }}
                                            color={colorButtonConfirm ? colorButtonConfirm : Colors.SPM600}
                                            onClick={EnvioEmail}
                                        >
                                            {confirmButtonMsg}
                                        </GenericSolidButton>
                                    </ButtonAreaContainer>   
                                    {
                                        resposta ? 
                                            <span style={{color: textColor, marginTop: 15, fontWeight: 'bold'}}>{resposta}</span> 
                                        : 
                                            ''
                                    }  
                                </>
                                
                            ) : (
                                <ButtonAreaContainer style={{ marginTop: 55 }}>
                                    <GenericSolidButton
                                      color={colorButtonConfirm ? colorButtonConfirm : Colors.SPM600}
                                        onClick={onConfirm}
                                    >
                                        Fechar
                                    </GenericSolidButton>
                                </ButtonAreaContainer> 
                            )
                        }

                    
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>
        </>
    )
    // --------------------------------------------------------

}

export default EmailModal